import React, { useEffect, useRef } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';
import Column from './Column';
import './Home.css';
import { useApp } from './../../AppProvider';
import { useAuth } from './../../AuthProvider';
import api from "./../../axiosInstance"
import logger from "../../utils/logger";
const Board = () => {
  const { boardData, setBoardData } = useApp();
  const { user, logout, isLoggingIn } = useAuth();
  const logoutTimer = useRef(null);

  useEffect(() => {
    if (isLoggingIn) return;

    if (!boardData && !user) {
      logoutTimer.current = setTimeout(() => {
        logout();
      }, 4000); // wait 4 seconds
    }

    if (user) {
      clearTimeout(logoutTimer.current);
    }

    return () => clearTimeout(logoutTimer.current);
  }, [boardData, user, isLoggingIn, logout]);

  const onDragEnd = async (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const start = boardData.columns[source.droppableId];
    const finish = boardData.columns[destination.droppableId];

    if (start === finish) {
      const newTaskIds = Array.from(start.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...start,
        taskIds: newTaskIds,
      };

      const newState = {
        ...boardData,
        columns: {
          ...boardData.columns,
          [newColumn.id]: newColumn,
        },
      };

      setBoardData(newState);
      return;
    }

    const startTaskIds = Array.from(start.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds,
    };

    const finishTaskIds = Array.from(finish.taskIds);
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds,
    };

    const newState = {
      ...boardData,
      columns: {
        ...boardData.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish,
      },
    };
    // Calling Ststus Change API
    try {
      await api.put(`/appointments/${draggableId}`, { status: destination.droppableId })
    } catch (error) {
      logger.error("Failed to update card status", error);
    }
    setBoardData(newState);
  };

  if (!boardData) {
    return <div className='boardDataNotAvil'>Board data not available yet!</div>;
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div style={{ display: 'flex', justifyContent: 'center', height: 'fit-content', marginLeft: 0, marginRight: 0 }}>
        {boardData.columnOrder.map((columnId) => {
          const column = boardData.columns[columnId];
          const tasks = column.taskIds.map((taskId) => boardData.tasks[taskId]);
          return <Column key={column.id} column={column} tasks={tasks} />;
        })}
      </div>
    </DragDropContext>
  );
};

export default Board;
